import React, { useContext as useContextCore } from 'react'
import type { TreeData } from './constants'
import type { TreeProps } from 'react-arborist/dist/main/types/tree-props'
import { Layout } from './Layout'

export type DataTreeProps = {
  data: TreeData[]
  parentIcon?: string | ((node: TreeData) => string)
  childIcon?: string | ((node: TreeData) => string)
  treeOptions?: TreeProps<TreeData>
}

export type ContextType = Omit<DataTreeProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const DataTree = ({ childIcon, parentIcon, treeOptions, ...props }: DataTreeProps) => {
  parentIcon = parentIcon ?? 'building-ngo'
  childIcon = childIcon ?? 'user'
  treeOptions = treeOptions ?? {}
  return (
    <CoreProvider value={{ parentIcon, childIcon, treeOptions, ...props }}>
      <Layout />
    </CoreProvider>
  )
}

export const useDataTreeContext = () => useContextCore(context)
